<template>
  <div id="app" :class="{ isMobile: isMobile }">
    <router-view />
  </div>
</template>

<script>
import { LOGIN_API } from "@/api.js";
export default {
  name: 'App',
  data() {
    return {
      isMobile: false,
      config: "",
    }
  },
  created() {
    console.log('app width:' + window.innerWidth)
    if (
      window.innerWidth <= 1200 ||
      navigator.userAgent.indexOf('Mobile') > -1
    ) {
      this.isMobile = true
      this.$store.dispatch('setDevice', 1)
    }
    this.$bus.on('loadSiteConfig', this.loadConfig)
  },
  methods: {
    loadConfig() {
      let post = {
        category: 1,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              let config = res.data.result[0].data
              console.log("load",config)
              this.$store.dispatch('setConfig', config)
              this.config = config;
              this.judgeConfig()
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    judgeConfig() {
      if (this.config && this.config.system && this.config.system.shutdown) {
        this.$router.push({ path: '/system' })
      }
    },
  },
}
</script>
<style lang="scss">
::-moz-selection {
  background: #29bdb9;
  color: #fff;
}

::selection {
  background: #29bdb9;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/App.vue